import * as React from "react";

class ButtonIText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="buttonI-text buttonHI-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 433.8 139.9"
      >
        <g>
          <path
            fill="#FCFAEE"
            d="M98.418,44.676h7.833v1.746h-5.744v3.691h4.861v1.764h-4.861v4.285h5.942v1.766h-8.031V44.676z"
          />
          <path
            fill="#FCFAEE"
            d="M108.462,55.299c0-2.125,1.801-3.223,5.924-3.674c-0.018-1.152-0.432-2.16-1.891-2.16
		c-1.044,0-2.017,0.469-2.863,1.008l-0.773-1.404c1.026-0.648,2.412-1.297,3.997-1.297c2.467,0,3.601,1.567,3.601,4.195v5.961
		h-1.692l-0.18-1.135h-0.054c-0.9,0.773-1.963,1.368-3.151,1.368C109.668,58.162,108.462,57.045,108.462,55.299z M114.386,55.372
		V52.94c-2.935,0.36-3.925,1.099-3.925,2.215c0,0.973,0.666,1.369,1.548,1.369C112.873,56.524,113.575,56.11,114.386,55.372z"
          />
          <path
            fill="#FCFAEE"
            d="M118.344,56.793l0.972-1.332c0.883,0.701,1.747,1.134,2.81,1.134c1.188,0,1.746-0.576,1.746-1.333
		c0-0.899-1.116-1.295-2.196-1.71c-1.314-0.504-2.827-1.206-2.827-2.881c0-1.656,1.332-2.899,3.511-2.899
		c1.333,0,2.413,0.541,3.224,1.171l-0.973,1.278c-0.685-0.504-1.387-0.863-2.215-0.863c-1.08,0-1.584,0.539-1.584,1.224
		c0,0.847,1.026,1.171,2.106,1.566c1.387,0.522,2.917,1.134,2.917,3.007c0,1.656-1.314,3.007-3.764,3.007
		C120.702,58.162,119.298,57.585,118.344,56.793z"
          />
          <path
            fill="#FCFAEE"
            d="M127.325,52.995c0-3.313,2.215-5.223,4.663-5.223c2.449,0,4.664,1.909,4.664,5.223
		c0,3.277-2.215,5.167-4.664,5.167C129.54,58.162,127.325,56.272,127.325,52.995z M134.527,52.995c0-2.107-0.973-3.512-2.539-3.512
		c-1.548,0-2.521,1.404-2.521,3.512c0,2.088,0.973,3.475,2.521,3.475C133.555,56.469,134.527,55.083,134.527,52.995z"
          />
          <path
            fill="#FCFAEE"
            d="M139.079,48.025h1.692l0.162,1.368h0.054c0.919-0.883,1.927-1.621,3.277-1.621
		c2.106,0,3.043,1.405,3.043,3.926v6.23h-2.07V51.95c0-1.711-0.505-2.395-1.675-2.395c-0.918,0-1.549,0.469-2.431,1.351v7.022
		h-2.053V48.025z"
          />
          <path
            fill="#FCFAEE"
            d="M155.046,47.395c-0.414,0.72-0.918,1.477-1.458,2.196v9.741h-1.639v-7.814
		c-0.595,0.63-1.225,1.225-1.818,1.711c-0.126-0.379-0.576-1.279-0.847-1.693c1.566-1.135,3.259-2.935,4.285-4.735L155.046,47.395z
		 M154.776,43.505c-1.099,1.603-2.81,3.295-4.412,4.376c-0.18-0.396-0.611-1.063-0.864-1.404c1.387-0.9,2.917-2.359,3.674-3.584
		L154.776,43.505z M165.417,53.138c-0.918,0.72-2.07,1.513-3.007,2.071c0.937,1.17,2.143,2.07,3.637,2.592
		c-0.359,0.342-0.882,0.99-1.134,1.441c-3.079-1.333-4.861-4.052-5.888-7.671h-1.477v5.51l2.881-0.667
		c-0.019,0.486,0.018,1.152,0.072,1.531c-3.602,0.954-4.214,1.152-4.592,1.422c-0.126-0.377-0.468-1.044-0.72-1.35
		c0.324-0.18,0.72-0.612,0.72-1.387V43.596h8.499v7.976h-3.907c0.288,0.9,0.666,1.729,1.098,2.485
		c0.919-0.576,2.017-1.423,2.701-2.071L165.417,53.138z M157.549,45.053v1.819h5.239v-1.819H157.549z M157.549,50.114h5.239v-1.873
		h-5.239V50.114z"
          />
          <path
            fill="#FCFAEE"
            d="M183.85,52.85v1.297h-16.205V52.85h4.339c-0.144-0.359-0.324-0.756-0.521-1.063l0.72-0.197h-1.908
		v-3.367h11.055v3.367h-1.458l0.306,0.054c-0.27,0.433-0.54,0.847-0.773,1.206H183.85z M174.847,45.215h-6.626V44.01h6.626v-1.225
		h1.692v1.225h6.771v1.205h-6.771v1.027h5.653v1.206h-12.729v-1.206h5.384V45.215z M169.949,54.993h11.722v4.34h-1.711v-0.504
		h-8.354v0.521h-1.656V54.993z M171.605,56.145v1.494h8.354v-1.494H171.605z M171.876,50.51h7.76v-1.207h-7.76V50.51z
		 M173.118,51.59c0.27,0.414,0.486,0.882,0.594,1.26h3.979c0.198-0.396,0.414-0.864,0.576-1.26H173.118z"
          />
          <path
            fill="#FCFAEE"
            d="M198.626,48.782c0,0.647-0.018,1.35-0.071,2.124c0.558,3.097,1.692,5.87,3.637,7.13
		c-0.36,0.324-0.847,0.937-1.08,1.404c-1.44-1.098-2.431-2.953-3.098-5.203c-0.485,1.782-1.35,3.619-2.898,5.203
		c-0.198-0.306-0.648-0.738-1.026-0.99v0.055h-5.834v0.846h-1.314v-5.834c-0.288,0.379-0.576,0.756-0.864,1.045
		c-0.144-0.252-0.521-0.883-0.756-1.135c0.954-0.954,1.872-2.34,2.413-3.745h-1.603v-3.276h3.583v3.276h-1.909l1.116,0.343
		c-0.144,0.342-0.287,0.666-0.468,1.008h1.963c-0.145-0.307-0.307-0.612-0.469-0.883l1.081-0.432
		c0.288,0.396,0.576,0.918,0.72,1.314h2.467v1.17h-2.557v0.9h2.196v1.117h-2.196v0.936h2.305v1.099h-2.305v1.062h2.431v0.828
		c2.845-3.023,3.061-6.823,3.061-9.398v-1.044h1.477V48.782z M187.841,45.09h-2.395v-1.242h2.395v-1.045h1.423v3.277h-1.423V45.09z
		 M187.175,48.763h1.459v-1.44h-1.459V48.763z M190.29,52.202h-2.035v0.9h2.035V52.202z M190.29,54.219h-2.035v0.936h2.035V54.219z
		 M188.255,57.315h2.035v-1.062h-2.035V57.315z M194.125,49.681h-3.547v-3.276h3.547V49.681z M192.45,46.081h-1.44v-3.277h1.44
		v1.045h2.359v1.224h-2.359V46.081z M193.063,47.34h-1.458v1.404h1.458V47.34z M196.735,46.999
		c-0.414,1.621-0.918,3.078-1.548,4.178c-0.288-0.271-0.954-0.793-1.314-1.027c1.099-1.729,1.71-4.501,2.034-7.346l1.549,0.252
		c-0.108,0.828-0.234,1.639-0.378,2.431h3.727l0.252-0.071l1.026,0.324c-0.342,1.656-0.81,3.564-1.278,4.771l-1.224-0.396
		c0.27-0.811,0.558-1.963,0.792-3.115H196.735z"
          />
          <path
            fill="#FCFAEE"
            d="M217.545,57.766c0.756,0,0.899-0.289,0.972-2.107c0.36,0.271,1.063,0.522,1.513,0.631
		c-0.216,2.377-0.685,2.988-2.341,2.988h-3.079c-2.017,0-2.503-0.486-2.503-2.143v-3.727h-0.216
		c-0.954,2.683-2.952,4.789-7.436,5.996c-0.162-0.433-0.576-1.063-0.919-1.423c3.817-0.937,5.618-2.558,6.519-4.573h-4.7v-4.34
		c-0.288,0.234-0.576,0.45-0.899,0.666c-0.253-0.377-0.774-0.953-1.171-1.225c2.503-1.619,4.249-3.889,5.186-5.743l1.801,0.324
		c-0.18,0.343-0.378,0.666-0.595,1.009h4.069l0.271-0.072l1.152,0.756c-0.45,0.828-1.135,1.783-1.818,2.629h5.222v5.996h-4.808V57.1
		c0,0.576,0.162,0.666,1.026,0.666H217.545z M210.559,51.932c0.234-0.955,0.342-1.98,0.432-3.043h-4.015v3.043H210.559z
		 M208.722,45.522c-0.468,0.631-1.008,1.278-1.584,1.891h4.249c0.468-0.559,0.973-1.26,1.368-1.891H208.722z M216.824,48.889h-4.087
		c-0.09,1.063-0.216,2.07-0.414,3.043h4.501V48.889z M215.654,53.516c0.882,0.685,1.998,1.675,2.521,2.395l-1.152,1.009
		c-0.486-0.72-1.585-1.782-2.484-2.521L215.654,53.516z"
          />
          <path
            fill="#FCFAEE"
            d="M237.85,52.346h-7.148v4.916c0,1.025-0.252,1.529-1.009,1.781c-0.756,0.271-1.944,0.307-3.619,0.307
		c-0.107-0.486-0.432-1.26-0.72-1.729c1.368,0.055,2.719,0.055,3.115,0.036c0.378-0.019,0.485-0.108,0.485-0.433v-4.879h-7.256
		v-1.675h7.256v-2.538c1.333-0.631,2.899-1.604,4.069-2.539h-9.542v-1.639h11.379l0.378-0.09l1.261,0.973
		c-1.53,1.477-3.745,3.096-5.798,4.177v1.656h7.148V52.346z"
          />
          <path
            fill="#FCFAEE"
            d="M244.128,48.348c0.63,0.721,2.196,2.684,2.557,3.17l-0.918,1.62c-0.343-0.63-1.026-1.71-1.639-2.628
		v8.84h-1.621v-7.706c-0.611,1.692-1.368,3.276-2.178,4.356c-0.181-0.504-0.595-1.134-0.883-1.529
		c1.206-1.604,2.358-4.322,2.935-6.681h-2.448v-1.548h2.574v-3.403h1.621v3.403h2.16v1.548h-2.16V48.348z M255.939,48.295h-2.341
		v8.768c0,1.099-0.288,1.604-0.954,1.873c-0.702,0.288-1.854,0.342-3.655,0.342c-0.09-0.486-0.36-1.296-0.612-1.764
		c1.351,0.053,2.61,0.035,3.007,0.035c0.36-0.018,0.522-0.144,0.522-0.504v-8.75h-5.078v-1.639h5.078v-3.781h1.692v3.781h2.341
		V48.295z M249.241,54.579c-0.36-1.135-1.188-2.916-1.944-4.213l1.422-0.594c0.811,1.314,1.639,3.024,2.017,4.177L249.241,54.579z"
          />
          <path
            fill="#FCFAEE"
            d="M273.489,45.612c0,0,0,0.576-0.019,0.793c-0.252,8.12-0.468,10.91-1.188,11.811
		c-0.45,0.595-0.883,0.757-1.567,0.847c-0.63,0.072-1.692,0.054-2.719,0c-0.035-0.45-0.233-1.152-0.54-1.62
		c1.152,0.09,2.197,0.107,2.647,0.107c0.359,0,0.558-0.054,0.756-0.306c0.576-0.595,0.811-3.313,1.044-10.101h-4.249
		c-0.504,1.152-1.063,2.196-1.639,3.024c-0.27-0.252-0.9-0.702-1.314-0.937v8.265h-4.879v1.368h-1.53V45.702h2.017
		c0.252-0.863,0.521-2.053,0.63-2.916l1.818,0.306c-0.306,0.9-0.648,1.854-0.937,2.61h2.881v3.403
		c1.188-1.548,2.143-3.942,2.684-6.319l1.62,0.377c-0.216,0.829-0.45,1.657-0.738,2.449H273.489z M259.823,47.161v3.421h3.349
		v-3.421H259.823z M263.172,56.019V52.04h-3.349v3.979H263.172z M269.168,54.615c-0.504-1.099-1.675-2.862-2.629-4.159l1.314-0.738
		c0.954,1.242,2.179,2.953,2.719,4.016L269.168,54.615z"
          />
          <path
            fill="#FCFAEE"
            d="M291.976,49.987v1.837h-16.385v-1.837H291.976z"
          />
          <path
            fill="#FCFAEE"
            d="M300.414,52.76c0.055,0.469,0.162,1.135,0.271,1.494c-4.213,1.908-4.844,2.251-5.239,2.611
		c-0.126-0.414-0.486-1.135-0.774-1.494c0.36-0.181,0.846-0.631,0.846-1.387V49.5l-1.962,0.396l-0.271-1.53l2.232-0.45v-4.375h1.621
		v4.051l3.187-0.648l0.271,1.514l-3.457,0.701v4.988L300.414,52.76z M309.651,44.297c0,0,0,0.648-0.019,0.883
		c-0.233,9.021-0.432,12.063-1.152,13.018c-0.414,0.612-0.846,0.811-1.476,0.9c-0.612,0.09-1.585,0.072-2.539,0.018
		c-0.019-0.468-0.234-1.206-0.522-1.691c1.009,0.071,1.891,0.09,2.287,0.09c0.342,0,0.504-0.072,0.702-0.343
		c0.54-0.63,0.792-3.583,0.972-11.289h-3.259c-0.126,5.618-0.521,10.713-5.077,13.485c-0.252-0.432-0.792-1.025-1.206-1.332
		c4.249-2.412,4.519-7.04,4.609-12.153h-2.701v-1.585H309.651z"
          />
          <path
            fill="#FCFAEE"
            d="M313.284,53.588c1.387-0.521,2.196-1.35,2.287-2.431c-0.072,0.019-0.162,0.019-0.252,0.019
		c-0.811,0-1.513-0.505-1.513-1.441c0-0.918,0.702-1.439,1.53-1.439c1.135,0,1.729,0.882,1.729,2.25
		c0,1.998-1.261,3.547-3.313,4.213L313.284,53.588z"
          />
          <path
            fill="#FCFAEE"
            d="M104.433,71.102c0,0,0,0.485-0.019,0.684c-0.162,5.545-0.342,7.508-0.811,8.139
		c-0.323,0.432-0.63,0.576-1.098,0.648c-0.396,0.071-1.045,0.071-1.711,0.053c-0.018-0.449-0.198-1.098-0.414-1.512
		c0.576,0.036,1.044,0.055,1.314,0.055c0.234,0,0.378-0.055,0.522-0.253c0.288-0.396,0.432-1.98,0.594-6.302h-2.017
		c-0.216,3.475-0.756,6.338-2.322,8.283c-0.271-0.396-0.811-0.973-1.225-1.243c1.837-2.269,1.98-6.104,2.034-10.821h-1.62v-1.549
		h3.403c-0.252-0.666-0.793-1.639-1.333-2.358l1.495-0.595c0.576,0.757,1.206,1.783,1.458,2.467l-1.225,0.486h3.529v1.549h-4.069
		c-0.018,0.774-0.036,1.549-0.054,2.27H104.433z M110.302,64.782c-0.107,0.359-0.216,0.738-0.36,1.098
		c0.919,1.818,2.593,3.746,4.231,4.664c-0.414,0.324-0.936,0.936-1.225,1.35c-1.386-0.953-2.754-2.592-3.727-4.375
		c-0.937,1.855-2.215,3.385-3.781,4.52c-0.252-0.45-0.738-0.99-1.17-1.351c2.088-1.296,3.69-3.601,4.483-6.356L110.302,64.782z
		 M107.151,76.143c1.638,0.828,3.889,2.143,4.987,3.078l-1.116,1.441c-1.045-0.973-3.26-2.359-4.952-3.26L107.151,76.143z
		 M110.284,74.936c-0.648-0.72-1.999-1.801-3.079-2.557l1.099-1.063c1.044,0.685,2.448,1.693,3.133,2.377L110.284,74.936z"
          />
          <path
            fill="#FCFAEE"
            d="M124.683,78.988c0.559,0.054,1.188,0.071,1.837,0.071c0.792,0.019,4.394,0,5.455-0.018
		c-0.233,0.379-0.485,1.117-0.576,1.584h-4.969c-3.439,0-5.726-0.504-7.202-2.79c-0.666,1.296-1.566,2.358-2.665,3.151
		c-0.252-0.307-0.882-0.919-1.242-1.189c1.836-1.17,2.952-3.15,3.402-5.653l1.675,0.234c-0.126,0.595-0.27,1.171-0.45,1.692
		c0.648,1.459,1.656,2.25,3.062,2.629v-5.041h-7.202v-1.477h15.772v1.477h-6.896v1.71h5.726v1.458h-5.726V78.988z M129.706,71.137
		h-12.117v-6.05h12.117V71.137z M128.014,66.331h-8.805v1.205h8.805V66.331z M128.014,68.707h-8.805v1.206h8.805V68.707z"
          />
          <path
            fill="#FCFAEE"
            d="M138.901,64.979c-0.485,1.333-1.134,2.647-1.836,3.908v12.045h-1.585v-9.597
		c-0.486,0.666-0.99,1.278-1.494,1.8c-0.162-0.414-0.648-1.314-0.918-1.691c1.692-1.675,3.295-4.304,4.267-6.933L138.901,64.979z
		 M147.112,79.293c1.063,0,1.242-0.468,1.404-2.539c0.396,0.271,1.044,0.541,1.494,0.631c-0.252,2.557-0.756,3.402-2.809,3.402
		h-4.43c-2.305,0-2.952-0.558-2.952-2.771v-5.475l-1.585,0.612l-0.666-1.476l2.251-0.883v-4.465h1.566v3.853l2.305-0.9v-4.79h1.494
		v4.195l2.701-1.062l0.233-0.181l1.261,0.414l-0.054,0.289c-0.072,2.574-0.271,5.959-0.612,8.102l-1.387-0.378
		c0.198-1.585,0.307-4.159,0.36-6.446l-2.503,0.99v6.465h-1.494v-5.889l-2.305,0.919v6.122c0,1.044,0.216,1.26,1.458,1.26H147.112z"
          />
          <path
            fill="#FCFAEE"
            d="M154.795,72.704c-0.72-0.63-2.16-1.459-3.331-1.944l0.883-1.261c1.152,0.433,2.61,1.188,3.367,1.801
		L154.795,72.704z M156.686,75.008c-0.918,1.873-2.124,4.016-3.187,5.708l-1.423-1.116c0.973-1.369,2.341-3.655,3.385-5.708
		L156.686,75.008z M155.804,67.842c-0.702-0.648-2.143-1.494-3.331-1.98l0.9-1.242c1.188,0.432,2.683,1.225,3.421,1.854
		L155.804,67.842z M162.069,74.073c-0.45,2.629-1.729,5.077-5.023,6.877c-0.307-0.342-0.918-0.936-1.351-1.188
		c2.935-1.549,4.159-3.529,4.628-5.689h-4.016v-1.566h4.268c0.054-0.631,0.071-1.297,0.071-1.945v-1.764h-3.402V67.23h3.402v-2.79
		h1.675v2.79h4.195v5.276h1.404v1.566H162.069z M162.321,70.561c0,0.648-0.018,1.297-0.072,1.945h2.629v-3.709h-2.557V70.561z
		 M164.176,74.378c1.261,1.8,3.007,4.249,3.854,5.689l-1.495,0.864c-0.773-1.459-2.448-3.979-3.745-5.852L164.176,74.378z"
          />
          <path
            fill="#FCFAEE"
            d="M178.521,78.826c0.793,0.144,1.657,0.181,2.575,0.181c0.792,0,3.799,0,4.825-0.019
		c-0.27,0.396-0.54,1.188-0.612,1.692h-4.303c-3.548,0-6.122-0.594-7.761-3.457c-0.594,1.53-1.44,2.809-2.557,3.781
		c-0.252-0.307-0.954-0.883-1.332-1.135c1.962-1.477,2.881-3.997,3.24-7.166l1.693,0.18c-0.108,0.793-0.234,1.566-0.415,2.27
		c0.648,1.692,1.657,2.646,2.917,3.205v-6.86h-4.159v-1.585h10.138v1.585h-4.25v2.61h5.149v1.566h-5.149V78.826z M171.805,70.507
		h-1.639v-4.124h6.788c-0.18-0.521-0.468-1.134-0.72-1.638l1.656-0.486c0.378,0.666,0.792,1.513,1.009,2.124h6.302v4.124h-1.711
		v-2.539h-11.686V70.507z"
          />
          <path
            fill="#FCFAEE"
            d="M203.219,65.34c0,0-0.018,0.432-0.018,0.666c-0.181,3.871-0.36,5.365-0.793,5.887
		c-0.323,0.379-0.647,0.504-1.17,0.576c-0.414,0.037-1.206,0.037-1.999,0c-0.035-0.432-0.216-1.063-0.45-1.439
		c0.721,0.054,1.405,0.072,1.675,0.054c0.271,0.019,0.433-0.019,0.576-0.181c0.234-0.306,0.396-1.387,0.522-4.105h-2.395
		c-0.307,2.737-1.081,4.862-3.71,6.104c-0.161-0.343-0.521-0.828-0.863-1.116l-0.667,0.288c-0.071-0.288-0.198-0.612-0.342-0.954
		c-3.691,0.99-4.304,1.206-4.663,1.458v-0.019c-0.162-0.359-0.612-0.99-0.864-1.224c0.288-0.271,0.702-0.81,0.702-1.675v-3.763
		c1.782-0.378,3.799-0.973,5.041-1.513l1.099,1.242c-1.278,0.486-2.935,0.918-4.501,1.261v3.511l2.574-0.63
		c-0.27-0.595-0.612-1.206-0.937-1.71l1.369-0.541c0.773,1.152,1.584,2.701,1.926,3.764c1.585-1.027,2.071-2.575,2.27-4.484h-1.927
		V65.34H203.219z M189.696,73.334h12.172v7.525h-1.765v-0.539h-8.714v0.611h-1.693V73.334z M191.39,74.684v1.494h3.547v-1.494
		H191.39z M194.937,78.969v-1.548h-3.547v1.548H194.937z M200.104,74.684h-3.583v1.494h3.583V74.684z M200.104,78.969v-1.548h-3.583
		v1.548H200.104z"
          />
          <path
            fill="#FCFAEE"
            d="M221.543,67.05v1.603h-9.687c-0.612,1.278-1.314,2.502-2.143,3.619v8.643h-1.675v-6.698
		c-0.576,0.558-1.206,1.099-1.873,1.566c-0.18-0.45-0.558-1.171-0.828-1.566c1.98-1.351,3.511-3.367,4.628-5.563h-4.142V67.05h4.861
		c0.378-0.882,0.648-1.765,0.883-2.647l1.746,0.433c-0.234,0.738-0.486,1.477-0.774,2.215H221.543z M217.006,78.952h4.519v1.566
		h-10.749v-1.566h4.538v-4.646h-3.854v-1.548h3.854v-3.242h1.692v3.242h3.835v1.548h-3.835V78.952z"
          />
          <path
            fill="#FCFAEE"
            d="M237.473,79.366c0.756,0,0.899-0.288,0.972-2.106c0.36,0.271,1.063,0.522,1.513,0.63
		c-0.216,2.377-0.685,2.989-2.341,2.989h-3.079c-2.017,0-2.503-0.486-2.503-2.144v-3.727h-0.216
		c-0.954,2.684-2.952,4.789-7.436,5.996c-0.162-0.432-0.576-1.063-0.919-1.422c3.817-0.938,5.618-2.558,6.519-4.574h-4.7v-4.34
		c-0.288,0.234-0.576,0.451-0.899,0.667c-0.253-0.378-0.774-0.954-1.171-1.225c2.503-1.62,4.249-3.89,5.186-5.743l1.801,0.324
		c-0.18,0.342-0.378,0.666-0.595,1.008h4.069l0.271-0.072l1.152,0.756c-0.45,0.828-1.135,1.783-1.818,2.629h5.222v5.996h-4.808V78.7
		c0,0.576,0.162,0.666,1.026,0.666H237.473z M230.486,73.532c0.234-0.954,0.342-1.98,0.432-3.043h-4.015v3.043H230.486z
		 M228.649,67.122c-0.468,0.631-1.008,1.279-1.584,1.891h4.249c0.468-0.558,0.973-1.26,1.368-1.891H228.649z M236.752,70.489h-4.087
		c-0.09,1.063-0.216,2.07-0.414,3.043h4.501V70.489z M235.582,75.117c0.882,0.685,1.998,1.675,2.521,2.395l-1.152,1.009
		c-0.486-0.721-1.585-1.783-2.484-2.521L235.582,75.117z"
          />
          <path
            fill="#FCFAEE"
            d="M257.777,73.946h-7.148v4.916c0,1.025-0.252,1.53-1.009,1.782c-0.756,0.271-1.944,0.306-3.619,0.306
		c-0.107-0.486-0.432-1.26-0.72-1.729c1.368,0.055,2.719,0.055,3.115,0.037c0.378-0.019,0.485-0.108,0.485-0.433v-4.88h-7.256
		v-1.674h7.256v-2.539c1.333-0.631,2.899-1.603,4.069-2.539h-9.542v-1.639h11.379l0.378-0.09l1.261,0.973
		c-1.53,1.477-3.745,3.097-5.798,4.178v1.656h7.148V73.946z"
          />
          <path
            fill="#FCFAEE"
            d="M264.056,69.95c0.63,0.719,2.196,2.682,2.557,3.168l-0.918,1.621
		c-0.343-0.631-1.026-1.711-1.639-2.629v8.84h-1.621v-7.705c-0.611,1.691-1.368,3.276-2.178,4.356
		c-0.181-0.504-0.595-1.134-0.883-1.53c1.206-1.603,2.358-4.321,2.935-6.68h-2.448v-1.549h2.574V64.44h1.621v3.402h2.16v1.549h-2.16
		V69.95z M275.867,69.895h-2.341v8.769c0,1.099-0.288,1.603-0.954,1.872c-0.702,0.289-1.854,0.343-3.655,0.343
		c-0.09-0.486-0.36-1.296-0.612-1.765c1.351,0.055,2.61,0.036,3.007,0.036c0.36-0.019,0.522-0.144,0.522-0.505v-8.75h-5.078v-1.639
		h5.078v-3.781h1.692v3.781h2.341V69.895z M269.169,76.178c-0.36-1.134-1.188-2.916-1.944-4.213l1.422-0.594
		c0.811,1.314,1.639,3.025,2.017,4.178L269.169,76.178z"
          />
          <path
            fill="#FCFAEE"
            d="M293.705,78.772v1.62h-15.989v-1.62h7.131V74.63h-5.132v-1.603h5.132v-3.602h-3.998
		c-0.558,1.081-1.152,2.035-1.782,2.791c-0.342-0.287-1.08-0.773-1.53-1.008c1.458-1.531,2.593-3.998,3.259-6.518l1.729,0.396
		c-0.27,0.919-0.594,1.837-0.937,2.7h3.26V64.44h1.729v3.348h6.266v1.639h-6.266v3.602h5.6v1.603h-5.6v4.142H293.705z"
          />
          <path
            fill="#FCFAEE"
            d="M298.777,72.704c-0.738-0.504-2.233-1.368-3.313-1.926l0.919-1.243
		c1.026,0.505,2.557,1.296,3.313,1.782L298.777,72.704z M295.824,79.6c0.954-1.351,2.341-3.655,3.385-5.689l1.207,1.115
		c-0.919,1.855-2.125,4.016-3.188,5.69L295.824,79.6z M299.623,67.842c-0.738-0.521-2.232-1.387-3.295-1.98l0.937-1.188
		c1.044,0.505,2.575,1.314,3.349,1.819L299.623,67.842z M307.113,71.245v2.666h3.709v6.932h-1.584v-0.666h-5.96v0.756h-1.53v-7.021
		h3.781v-2.666h-5.006v-1.602h5.006v-2.557c-1.261,0.197-2.557,0.342-3.745,0.432c-0.072-0.396-0.288-1.025-0.486-1.404
		c3.079-0.324,6.572-0.9,8.553-1.639l1.314,1.297c-1.152,0.432-2.557,0.773-4.052,1.044v2.827h4.771v1.602H307.113z M309.238,75.422
		h-5.96v3.241h5.96V75.422z"
          />
          <path
            fill="#FCFAEE"
            d="M113.687,100.102v1.71H97.698v-1.71h5.203v-9.039H98.13v-1.656h3.871
		c-0.306-0.828-0.936-1.963-1.53-2.791l1.495-0.559c0.702,0.9,1.422,2.143,1.71,2.971l-0.882,0.379h5.203l-0.36-0.127
		c0.612-0.882,1.351-2.268,1.747-3.276l1.854,0.522c-0.576,1.008-1.225,2.07-1.801,2.881h3.817v1.656h-4.861v9.039H113.687z
		 M100.399,92.612c0.846,1.764,1.512,4.051,1.71,5.563l-1.62,0.434c-0.145-1.531-0.793-3.836-1.585-5.601L100.399,92.612z
		 M104.576,100.102h2.143v-9.039h-2.143V100.102z M109.006,98.174c0.666-1.494,1.458-3.924,1.836-5.707l1.801,0.414
		c-0.63,1.98-1.44,4.25-2.125,5.727L109.006,98.174z"
          />
          <path
            fill="#FCFAEE"
            d="M130.732,100.768c0,0.738-0.18,1.08-0.738,1.297c-0.594,0.197-1.477,0.18-2.736,0.18
		c-0.09-0.396-0.343-0.865-0.522-1.225c0.9,0.035,1.782,0.035,2.017,0.018c0.252-0.018,0.324-0.072,0.324-0.287v-1.081h-4.592v2.862
		h-1.656v-2.862h-4.267v2.593h-1.621v-3.764h5.888V97.76h-4.987v-4.213h5.006c0.144-0.306,0.288-0.666,0.378-0.954
		c-2.701,0.216-5.42,0.45-7.364,0.595l-0.108-1.063l3.241-0.217v-0.828h-2.755v-0.918h2.755V89.46h-3.133v-0.9h3.133v-0.702h-2.484
		v-0.883h2.484v-0.953h1.584v0.953h2.594v0.883h-2.594v0.702h3.115v0.9h-3.115v0.702h2.791v0.918h-2.791v0.738
		c1.045-0.072,2.144-0.162,3.241-0.234l-0.018,0.847l1.08,0.216c-0.18,0.324-0.36,0.631-0.522,0.9h5.366v4.213h-5.24v0.738h6.248
		V100.768z M119.335,95.204h8.841v-0.701h-8.841V95.204z M119.335,96.807h8.841v-0.703h-8.841V96.807z M131.705,87.534v1.261h-1.818
		v2.899c0,0.701-0.145,0.99-0.648,1.188c-0.54,0.217-1.261,0.234-2.341,0.234c-0.108-0.396-0.342-0.883-0.559-1.225
		c0.757,0.018,1.477,0.018,1.693,0.018c0.233-0.018,0.306-0.072,0.306-0.27v-2.845h-4.52v-1.261h4.52V86.04h1.549v1.494H131.705z
		 M126.087,91.675c-0.27-0.612-0.954-1.513-1.548-2.144l1.098-0.576c0.612,0.595,1.314,1.459,1.621,2.035L126.087,91.675z"
          />
          <path
            fill="#FCFAEE"
            d="M133.23,94.124c0.45-1.188,0.756-3.168,0.864-4.627l1.224,0.162
		c-0.054,1.512-0.359,3.583-0.828,4.897L133.23,94.124z M137.569,86.022v16.51h-1.639v-16.51H137.569z M142.737,91.17v7.887
		c0,0.918,0.252,1.242,1.08,1.242h3.835c0.576,0,1.351-0.054,1.765-0.144c0.054,0.45,0.126,1.206,0.198,1.585
		c-0.36,0.107-1.171,0.144-1.999,0.144h-3.709c-2.143,0-2.845-0.72-2.845-2.899V91.17h-1.44c0.144,0.433,0.288,0.793,0.396,1.1
		l-1.135,0.539c-0.234-0.863-0.828-2.305-1.314-3.402l1.08-0.433c0.271,0.612,0.595,1.333,0.883,1.999v-1.404h10.425v1.602H142.737z
		 M144.682,89.479c-0.288-0.775-0.864-2.107-1.351-3.08l1.639-0.594c0.504,0.937,1.134,2.215,1.44,2.971L144.682,89.479z"
          />
          <path
            fill="#FCFAEE"
            d="M165.473,100.965c0.756,0,0.899-0.287,0.972-2.105c0.36,0.27,1.063,0.521,1.513,0.629
		c-0.216,2.377-0.685,2.99-2.341,2.99h-3.079c-2.017,0-2.503-0.486-2.503-2.143v-3.729h-0.216c-0.954,2.684-2.952,4.79-7.436,5.996
		c-0.162-0.432-0.576-1.063-0.919-1.422c3.817-0.937,5.618-2.557,6.519-4.574h-4.7V92.27c-0.288,0.233-0.576,0.449-0.899,0.666
		c-0.253-0.379-0.774-0.955-1.171-1.225c2.503-1.621,4.249-3.89,5.186-5.744l1.801,0.324c-0.18,0.342-0.378,0.666-0.595,1.008h4.069
		l0.271-0.072l1.152,0.757c-0.45,0.829-1.135,1.782-1.818,2.629h5.222v5.995h-4.808v3.691c0,0.576,0.162,0.666,1.026,0.666H165.473z
		 M158.486,95.132c0.234-0.954,0.342-1.981,0.432-3.043h-4.015v3.043H158.486z M156.649,88.722c-0.468,0.63-1.008,1.278-1.584,1.891
		h4.249c0.468-0.558,0.973-1.261,1.368-1.891H156.649z M164.752,92.089h-4.087c-0.09,1.062-0.216,2.07-0.414,3.043h4.501V92.089z
		 M163.582,96.717c0.882,0.684,1.998,1.674,2.521,2.395l-1.152,1.008c-0.486-0.721-1.585-1.783-2.484-2.521L163.582,96.717z"
          />
          <path
            fill="#FCFAEE"
            d="M183.473,100.965c0.756,0,0.899-0.287,0.972-2.105c0.36,0.27,1.063,0.521,1.513,0.629
		c-0.216,2.377-0.685,2.99-2.341,2.99h-3.079c-2.017,0-2.503-0.486-2.503-2.143v-3.729h-0.216c-0.954,2.684-2.952,4.79-7.436,5.996
		c-0.162-0.432-0.576-1.063-0.919-1.422c3.817-0.937,5.618-2.557,6.519-4.574h-4.7V92.27c-0.288,0.233-0.576,0.449-0.899,0.666
		c-0.253-0.379-0.774-0.955-1.171-1.225c2.503-1.621,4.249-3.89,5.186-5.744l1.801,0.324c-0.18,0.342-0.378,0.666-0.595,1.008h4.069
		l0.271-0.072l1.152,0.757c-0.45,0.829-1.135,1.782-1.818,2.629h5.222v5.995h-4.808v3.691c0,0.576,0.162,0.666,1.026,0.666H183.473z
		 M176.486,95.132c0.234-0.954,0.342-1.981,0.432-3.043h-4.015v3.043H176.486z M174.649,88.722c-0.468,0.63-1.008,1.278-1.584,1.891
		h4.249c0.468-0.558,0.973-1.261,1.368-1.891H174.649z M182.752,92.089h-4.087c-0.09,1.062-0.216,2.07-0.414,3.043h4.501V92.089z
		 M181.582,96.717c0.882,0.684,1.998,1.674,2.521,2.395l-1.152,1.008c-0.486-0.721-1.585-1.783-2.484-2.521L181.582,96.717z"
          />
          <path
            fill="#FCFAEE"
            d="M192.308,86.526c-0.396,1.188-0.864,2.395-1.404,3.547v12.459h-1.585v-9.543
		c-0.468,0.738-0.936,1.405-1.44,1.981c-0.144-0.414-0.576-1.351-0.828-1.765c1.494-1.746,2.881-4.411,3.709-7.112L192.308,86.526z
		 M197.313,93.637h-3.367v8.859h-1.549V87.012h4.916V93.637z M193.946,88.308v1.368h2.07v-1.368H193.946z M196.017,92.36v-1.459
		h-2.07v1.459H196.017z M203.381,100.498c0,0.973-0.216,1.458-0.864,1.729c-0.666,0.253-1.746,0.288-3.421,0.288
		c-0.072-0.449-0.342-1.17-0.559-1.62c1.207,0.054,2.449,0.054,2.81,0.036c0.323-0.018,0.449-0.127,0.449-0.451v-6.842h-3.547
		v-6.625h5.132V100.498z M199.618,88.308v1.368h2.178v-1.368H199.618z M201.796,92.36v-1.459h-2.178v1.459H201.796z"
          />
          <path
            fill="#FCFAEE"
            d="M209.229,91.495c1.566,0,2.809,1.261,2.809,2.809c0,1.549-1.242,2.81-2.809,2.81
		c-1.549,0-2.809-1.261-2.809-2.81C206.42,92.755,207.68,91.495,209.229,91.495z M209.229,96.032c0.954,0,1.729-0.773,1.729-1.729
		c0-0.953-0.774-1.729-1.729-1.729c-0.937,0-1.729,0.775-1.729,1.729C207.5,95.258,208.292,96.032,209.229,96.032z"
          />
        </g>
      </svg>
    );
  }
}

export default ButtonIText;



// WEBPACK FOOTER //
// ./src/storyE/components/ButtonIText.tsx